import { checkClaimApi } from "@/api/user";

export default {
  namespaced: true,
  state: {
    isClaimed: false,
  },
  getters: {
    isClaimed: (state: any) => state.isClaimed,
  },
  mutations: {
    SET_IS_CLAIMED(state: any, payload: any) {
      state.isClaimed = payload;
    },
  },
  actions: {
    async checkClaim(context: any, payload: any) {
      try {
        const response = await checkClaimApi(payload);

        if (response.status === 200) {
          context.commit("SET_IS_CLAIMED", response.data.data);
        }
      } catch (error: any) {
        const errorCode = error.response.data.errorCode;
        if (errorCode === 515) {
          context.commit("SET_IS_CLAIMED", true);
        }
      }
    },
  },
};
